import momentPackage from 'moment';

// The legacy CakePHP page puts its own moment on `window`; reuse that instance when it is there so
// both halves of the page share one locale and plugin setup. Outside that page (Storybook, tests,
// the standalone bundle) there is nothing on `window`, so fall back to the bundled package. The
// previous `require('moment')` fallback threw `require is not defined` once the build moved to ESM.
export default (typeof window !== 'undefined' && window['moment']) || momentPackage;
